export const ProjectList = [
    {
        name: `TradingView Charting`,
        image: `https://user-images.githubusercontent.com/73634195/245564815-fde4f238-9261-4988-8857-e9ff25461cc7.png`,
        tech_stack: `TypeScript, NextJs, ReactJs, HTML, CSS, JS, Lightweight Charts`,
        github_link: `https://github.com/prabhashrai02/algo-test-trading-chart`,
        live_link: `https://algo-test-trading-chart.vercel.app/`,
    },
    {
        name: `Custom Tooltip Component`,
        image: `https://user-images.githubusercontent.com/73634195/245682479-69377d5e-0013-4874-b13d-4a21d019ade7.png`,
        tech_stack: `TypeScript, NextJs, ReactJs, HTML, CSS, JS`,
        github_link: `https://github.com/prabhashrai02/custom-tooltip`,
        live_link: `https://custom-tooltip.vercel.app/`,
    },
    {
        name: `GrowwMart`,
        image: `https://user-images.githubusercontent.com/73634195/243904761-34b20b08-acf5-4200-87b6-f89f968fa396.png`,
        tech_stack: `TypeScript, NextJs, ReactJs, HTML, CSS, JS`,
        github_link: `https://github.com/prabhashrai02/growwmart`,
        live_link: `https://growwmart-raiprabh-growwin.vercel.app/`,
    },
    {
        name: `Groww Feed App`,
        image: `https://user-images.githubusercontent.com/73634195/199815021-b4d0fef6-9b79-484f-adde-b9d5b3c32939.png`,
        tech_stack: `ReactJs, HTML, CSS, JS`,
        github_link: `https://github.com/prabhashrai02/groww-feed-app`,
        live_link: `https://prabhashrai02.github.io/groww-feed-app/`,
    },
    {
        name: `Search Image`,
        image: `https://user-images.githubusercontent.com/73634195/148273357-5d605c96-94bb-42c5-9637-95b48435b731.png`,
        tech_stack: `ReactJs, HTML, CSS, JS`,
        github_link: `https://github.com/prabhashrai02/image_search`,
        live_link: `https://prabhashrai02.github.io/image_search/`,
    },
    {
        name: `Dukaan Slogan Generator`,
        image: `https://user-images.githubusercontent.com/73634195/161261058-66fc2215-0410-4194-a913-451a7a6ca827.png`,
        tech_stack: `ReactJs, HTML, CSS, JS`,
        github_link: `https://github.com/prabhashrai02/dukaan`,
        live_link: `https://prabhashrai02.github.io/dukaan/`,
    },
    {
        name: `Notes App`,
        image: `https://user-images.githubusercontent.com/73634195/194009125-2cd08aa1-ab0e-4d83-8454-d1aa0990d3e6.png`,
        tech_stack: `Dart, Flutter, Firebase`,
        github_link: `https://github.com/prabhashrai02/notes-app`,
        live_link: `https://drive.google.com/file/d/1Nt28M9LfkWRVlzcgvPr79kW_Og8pfEOi/view?usp=sharing`,
    },
    {
        name: `Intraday Helper`,
        image: `https://user-images.githubusercontent.com/73634195/193598590-3ec24418-9795-404f-8cff-61fa127ef189.png`,
        tech_stack: `HTML, CSS, JS`,
        github_link: `https://github.com/prabhashrai02/intradayhelper`,
        live_link: `https://prabhashrai02.github.io/intradayhelperStatic/`,
    },
    {
        name: `Bank Manger View`,
        image: `https://user-images.githubusercontent.com/73634195/154430424-54290b35-787f-4cce-9033-b20426705748.png`,
        tech_stack: `ReactJs, HTML, CSS, JS`,
        github_link: `https://github.com/prabhashrai02/banking_management_-manager-view-`,
        live_link: `https://prabhashrai02.github.io/banking_management_-manager-view-/`,
    },
    {
        name: `Water Tank Visualizer`,
        image: `https://user-images.githubusercontent.com/73634195/197586973-0872e496-becb-4209-8078-e15b330153a5.png`,
        tech_stack: `HTML, CSS, JS`,
        github_link: `https://github.com/prabhashrai02/water_tank_visualizer`,
        live_link: `https://prabhashrai02.github.io/water_tank_visualizer/`,
    },
]
